/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GcpRoleAndPrincipalOperationEnum } from './gcpRoleAndPrincipalOperationEnum';


export interface ModifyPolicySpec { 
    operation: GcpRoleAndPrincipalOperationEnum;
    /**
     * Principals to add/remove based on operation
     */
    principals: Array<string>;
    /**
     * Policy Role Name
     */
    role: string;
}
export namespace ModifyPolicySpec {
}


